exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "small[data-v-2ef5afc5]{color:gray}.shorten-long-text[data-v-2ef5afc5]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.acl-public[data-v-2ef5afc5]{color:#00b400}.acl-intern[data-v-2ef5afc5]{color:#dacd00}.acl-privat[data-v-2ef5afc5]{color:#be0000}.btn[data-v-2ef5afc5]{padding:4px 10px}.cc-btn-menue[data-v-2ef5afc5]{padding-left:5px;padding-right:0}.media[data-v-2ef5afc5]{margin-top:0}.media-right[data-v-2ef5afc5]{white-space:nowrap}.media-left[data-v-2ef5afc5]{padding-left:5px}.cc-kombox-typ[data-v-2ef5afc5]{padding-bottom:30px}.cc-kombox-body[data-v-2ef5afc5]{border-left:0 solid red;padding-left:8px;line-height:1.1em;word-break:break-word}.media-left .glyphicon[data-v-2ef5afc5]{padding-right:0;font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2ef5afc5&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Kombox.vue
// module id = 194
// module chunks = 0